<template>
  <v-container>
    <MjGooglePermissions :scope-prop='[{name: "Google Calendar",url: "https://www.googleapis.com/auth/calendar",authorized: false},]'/>
  </v-container>
</template>


<script>
import MjGooglePermissions from "@/components/MjGooglePermissions.vue";

export default {
  name: "GooglePermission",
  components: { MjGooglePermissions },
  created() {},
  computed: {},
  data: () => ({
    //lista su https://developers.google.com/identity/protocols/oauth2/scopes
    
      

  }),
  methods: {},
};
</script>
